import React, { useState, useEffect, useRef } from "react";
import { handleIcon } from './filemanager-utils'

import "./file-item.css";

function FileItem({ file, isCutting, onDoubleClick, onClickFile, onMultiSelectionClicked, selectedFiles }) {
	const [selected, setSelected] = useState(false);

	useEffect(() => {
		setSelected(selectedFiles.includes(file));
	}, [selectedFiles, file]);

	const handleClick = (event) => {
		event.stopPropagation();
		onClickFile(event);

/*
		if (clickTimeout.current) {
			clearTimeout(clickTimeout.current);
			clickTimeout.current = null;
			onDoubleClick();
		} else {
			clickTimeout.current = setTimeout(() => {
				onClickFile(event);
				clickTimeout.current = null;
			}, 200);
		}
*/
	};

	const handleDblClick = (event) => {
		event.stopPropagation();
		onDoubleClick();
	};

	const handleMultiClick = (event) => {
		event.stopPropagation();
		onMultiSelectionClicked(file);
	};

	return (
		<div id={`file-${file.alias}`} className={`file-item ${selected ? "selected" : ""} ${selected && isCutting ? "cutting" : ""} ${file.isShared || file.wasShared ? "shared-item" : ""}`} >
			<span className="check-card" data-alias={file.alias} onClick={handleClick} onDoubleClick={handleDblClick} ></span>
			<span className="check-icon" onClick={event => handleMultiClick(event)}>
				<em className={`la la-${selected ? "check" : "square"}`}></em>
			</span>
			{file.wasShared ? <em className="la la-share-square isShare"></em> : null}
			{file.isShared ? <em className="la la-user-friends isShare"></em> : null}
			{handleIcon(file)}
		   
			<span className="file-name">{file.name}</span>
		</div>
	);
}

export default FileItem;
